import React, { useRef, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../../../images/StartPoint-logo.png";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { logout } from "../../../actions/auth";

const Sidebar = ({ auth: { isAuthenticated }, logout }) => {
  let get_token = localStorage.getItem("token");

  const [isOpen, setIsOpen] = useState(false);
  const toggleBtn = useRef();
  const sidebarBtn = useRef();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <nav className={`sidebar ${isOpen ? "" : "close"}`} ref={sidebarBtn}>
        <header>
          <div className="sidebar_logo">
            <div className="img-text">
              <span className="img-logo">
                <img src={logo} alt="Logo" />
              </span>
            </div>
            <FontAwesomeIcon
              icon="fa-solid fa-angle-right"
              ref={toggleBtn}
              className="toggle custom-icon"
              onClick={toggleSidebar}
            />
          </div>
        </header>

        <div className={`menu-bar ${isOpen ? "" : "hide"}`}>
          <div className="menu" >
            <ul className="menu-links">
              <li className="nav-link">
                <Link to="/" onClick={() => setIsOpen(false)}>
                  <FontAwesomeIcon
                    icon="fa-solid fa-house"
                    className="nav-icon"
                  />
                  <span className="txt nav-text">Ana səhifə</span>
                </Link>
              </li>

              <li className="nav-link">
                <Link to="/packages" onClick={() => setIsOpen(false)}>
                  <FontAwesomeIcon
                    icon="fa-solid fa-dumbbell"
                    className="nav-icon"
                  />
                  <span className="txt nav-text">Paketlər</span>
                </Link>
              </li>

              <li className="nav-link">
                <Link to="/subscriptions" onClick={() => setIsOpen(false)}>
                  <FontAwesomeIcon
                    icon="fa-solid fa-address-card"
                    className="nav-icon"
                  />
                  <span className="txt nav-text">Abunəliklər</span>
                </Link>
              </li>
              <li className="nav-link">
                <Link to="/marketing" onClick={() => setIsOpen(false)}>
                  <FontAwesomeIcon
                    icon="fa-solid fa-bullhorn"
                    className="nav-icon"
                  />
                  <span className="txt nav-text">Marketinq</span>
                </Link>
              </li>
              <li className="nav-link">
                <Link to="/expenses" onClick={() => setIsOpen(false)}>
                  <FontAwesomeIcon
                    icon="fa-solid fa-money-bill-transfer"
                    className="nav-icon"
                  />
                  <span className="txt nav-text">Xərclər</span>
                </Link>
              </li>
              <li className="nav-link">
                <Link to="/incomes" onClick={() => setIsOpen(false)}>
                  <FontAwesomeIcon
                    icon="fa-solid fa-wallet"
                    className="nav-icon"
                  />
                  <span className="txt nav-text">Gəlirlər</span>
                </Link>
              </li>
              <li className="nav-link">
                <Link to="/class" onClick={() => setIsOpen(false)}>
                  <FontAwesomeIcon
                    icon="fa-solid fa-calendar-days"
                    className="nav-icon"
                  />
                  <span className="txt nav-text">Siniflər</span>
                </Link>
              </li>
              <li className="nav-link">
                <Link to="/crm" onClick={() => setIsOpen(false)}>
                  <FontAwesomeIcon
                    icon="fa-solid fa-clipboard-question"
                    className="nav-icon"
                  />
                  <span className="txt nav-text">CRM</span>
                </Link>
              </li>
              <li className="nav-link">
                <Link to="/trainerpayment" onClick={() => setIsOpen(false)}>
                  <FontAwesomeIcon
                    icon="fa-solid fa-person-walking"
                    className="nav-icon"
                  />
                  <span className="txt nav-text">Təlimçi ödənişi</span>
                </Link>
              </li>
              <li className="nav-link">
                <Link to="/startpointpayment" onClick={() => setIsOpen(false)}>
                  <FontAwesomeIcon
                    icon="fa-solid fa-location-dot"
                    className="nav-icon"
                  />
                  <span className="txt nav-text">StartPoint ödənişi</span>
                </Link>
              </li>
              <li className="nav-link">
                <Link to="/settings" onClick={() => setIsOpen(false)}>
                  <FontAwesomeIcon
                    icon="fa-solid fa-gear"
                    className="nav-icon"
                  />
                  <span className="txt nav-text">Tənzimləmələr</span>
                </Link>
              </li>
            </ul>
          </div>
          <div className="bottom-content">
            <li className="nav-link">
              <Link onClick={logout} className="operator-dropdown__link">
                <FontAwesomeIcon
                  icon="fa-solid fa-arrow-right-from-bracket"
                  className="nav-icon"
                />
                <span className="txt nav-text">Çıxış</span>
              </Link>
            </li>
          </div>
        </div>
      </nav>
    </>
  );
};

Sidebar.propTypes = {
  logout: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logout })(Sidebar);
